"use client";

import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import L2subjectList from "@packages/shared-components/sr-page/SrFilter/L2subjectList";
import RightArrowSvg from "../../right-arrow-svg";
import { generatePathName } from "@packages/lib/utlils/filters/result-filters";
import { sanitizeInput } from "@packages/lib/utlils/sanitization";
import { useFilterContext } from "@packages/lib/utlils/use-context/filter-context";
import Accordion from "@packages/shared-components/common-utilities/accordion/accordion";
const SubjectAccordianFilter = ({
  jsondata,
  keyName,
  formUrl,
  appendSearchParams,
  subjectClicked,
}: any) => {
  const {
    slug,
    prepopulateFilter,
    setPrepopulateFilter,
    subjectState,
    setSubjectState,
    filterState,
  } = useFilterContext();
  const parentSubjectList: any = Array.from(
    new Set(
      jsondata?.subjectFilterList?.filter(
        (item: any) => item?.parentSubject == null,
      ),
    ),
  );

  const L2subjects = parentSubjectList?.map((item: any) => {
    const filteredSubjects = jsondata?.subjectFilterList?.filter(
      (subject: any) => subject?.parentSubject === item?.categoryDesc,
    );
    return { parent: item?.categoryDesc, subjects: filteredSubjects };
  });

  const subjectKeyWordSearch = (keyword: string) => {
    if (keyword?.length >= 3) {
      const filteredSubject = jsondata?.subjectFilterList?.filter(
        (subject: any) =>
          subject?.categoryDesc
            ?.toLowerCase()
            .startsWith(keyword?.toLowerCase()),
      );
      setSubjectState((prev: any) => ({
        ...prev,
        subjectkeyword: keyword,
        isSujectDropdownOpen: true,
        sortedSubjects: filteredSubject,
      }));
    } else if (keyword?.length < 3) {
      setSubjectState((prev: any) => ({
        ...prev,
        subjectkeyword: keyword,
        isSujectDropdownOpen: false,
      }));
    }
  };

  return (
    <Accordion
      title="Subject"
      id="#subject"
      defaultOpenStatus={
        filterState?.selectedFilter === "all" ||
        filterState?.selectedFilter === "subject"
      }
    >
      <div className="flex flex-col gap-[24px] pt-[24px]">
        {jsondata?.studyMethodList?.length > 0 && (
          <div className="flex flex-col gap-[4px]">
            <div className="text-para-lg font-semibold">Study method</div>
            <div className="x-small font-semibold text-black uppercase">
              Choose one
            </div>
            <div className="flex flex-wrap gap-[8px]">
              {jsondata?.studyMethodList?.map(
                (studyMethodChild: any, index: number) => (
                  <div className="form-black flex relative" key={index + 1}>
                    {/* <Link
                      className="hidden"
                      id={
                        keyName?.studyMethod +
                        studyMethodChild?.studyMethodTextKey
                      }
                      href={{
                        pathname: generatePathName(slug, keyName?.studyMethod),
                        query: formUrl(
                          keyName?.studyMethod,
                          studyMethodChild?.studyMethodTextKey
                        ),
                      }}
                    >
                      {studyMethodChild?.studyMethodDesc}
                    </Link> */}
                    <input
                      checked={
                        prepopulateFilter?.studyMethod ==
                        studyMethodChild?.studyMethodTextKey
                      }
                      onChange={() => {
                        setPrepopulateFilter((prev: any) => ({
                          ...prev,
                          studyMethod:
                            prev?.studyMethod ==
                            studyMethodChild?.studyMethodTextKey
                              ? ""
                              : studyMethodChild?.studyMethodTextKey,
                        }));
                        appendSearchParams(
                          keyName?.studyMethod,
                          sanitizeInput(studyMethodChild?.studyMethodTextKey),
                        );
                      }}
                      type="checkbox"
                      id={studyMethodChild?.studyMethodDesc}
                      name={studyMethodChild?.studyMethodDesc}
                      className="rounded-[4px] outline-none absolute opacity-0"
                    />
                    <label
                      htmlFor={studyMethodChild?.studyMethodDesc}
                      className="btn btn-black-outline"
                    >
                      {studyMethodChild?.studyMethodDesc}
                    </label>
                  </div>
                ),
              )}
            </div>
          </div>
        )}
        {jsondata?.studyModeList && (
          <div className="flex flex-col gap-[4px]">
            <div className="text-para-lg font-semibold">Study mode</div>
            <div className="x-small font-semibold text-black uppercase">
              Choose one
            </div>
            <div className="flex flex-row flex-wrap gap-[8px]">
              {jsondata?.studyModeList?.map((studyModeChild: any) => (
                <div
                  className="form-black flex relative"
                  key={studyModeChild?.studyModeTextKey + 1}
                  id={studyModeChild?.studyModeTextKey}
                >
                  <Link
                    className="hidden"
                    id={keyName?.studyMode + studyModeChild?.studyModeTextKey}
                    href={{
                      pathname: generatePathName(slug, keyName?.studyMode),
                      query: formUrl(
                        keyName?.studyMode,
                        studyModeChild?.studyModeTextKey,
                      ),
                    }}
                  >
                    {studyModeChild?.studyModeDesc}
                  </Link>
                  <input
                    type="checkbox"
                    checked={
                      prepopulateFilter?.studyMode ==
                      studyModeChild?.studyModeTextKey
                    }
                    onChange={() => {
                      appendSearchParams(
                        keyName?.studyMode,
                        studyModeChild?.studyModeTextKey,
                      );
                    }}
                    className="rounded-[4px] outline-none absolute opacity-0"
                    id={studyModeChild?.studyModeDesc}
                    name={studyModeChild?.studyModeDesc}
                  />
                  <label
                    htmlFor={studyModeChild?.studyModeDesc}
                    className="btn btn-black-outline"
                  >
                    {studyModeChild?.studyModeDesc}
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}
        {jsondata?.qualificationList?.length > 0 && (
          <div className="flex flex-col gap-[4px]">
            <div className="text-para-lg font-semibold">
              {process.env.PROJECT === "Whatuni"
                ? "Study level"
                : "Qualification"}
            </div>
            <div className="x-small font-semibold text-black">Choose one</div>
            {process.env.PROJECT !== "Whatuni" && (
              <>
                {jsondata?.qualificationList?.some(
                  (quals: any) => quals?.qualSection === "Taught",
                ) && (
                  <>
                    <div className="x-small font-semibold text-black">
                      Taught:
                    </div>
                    <div className="flex flex-wrap gap-[8px]">
                      {jsondata?.qualificationList
                        ?.filter(
                          (qualitem: any) => qualitem?.qualSection === "Taught",
                        )
                        ?.map((qualChild: any, index: number) => (
                          <div className="form-black flex relative" key={index}>
                            {slug?.split("/")[1] !==
                              `${qualChild?.qualTextKey}-courses` && (
                              <Link
                                className="hidden"
                                id={
                                  keyName?.studyLevel + qualChild?.qualTextKey
                                }
                                href={{
                                  pathname: "/pgs/search",
                                  query: formUrl(
                                    keyName?.studyLevel,
                                    qualChild?.qualTextKey,
                                    false,
                                    qualChild?.subjectTextKey?.replaceAll(
                                      ",",
                                      "+",
                                    ),
                                  ),
                                }}
                              >
                                {qualChild?.qualDisplayDesc}
                              </Link>
                            )}
                            <input
                              checked={
                                filterState?.filterOrder?.qualification ==
                                  qualChild?.qualTextKey ||
                                prepopulateFilter?.studyLevel ===
                                  `${qualChild?.qualTextKey}-courses`
                              }
                              type="radio"
                              name="studylevel"
                              id={qualChild?.qualDisplayDesc}
                              value={qualChild?.qualDisplayDesc}
                              onChange={() => {
                                appendSearchParams(
                                  keyName?.studyLevel,
                                  qualChild?.qualTextKey,
                                  false,
                                  true,
                                  qualChild?.subjectTextKey?.replaceAll(
                                    ",",
                                    "+",
                                  ),
                                );
                              }}
                              className="rounded-[4px] outline-none absolute opacity-0"
                            />
                            <label
                              htmlFor={qualChild?.qualDisplayDesc}
                              className="btn btn-black-outline"
                            >
                              {qualChild?.qualDisplayDesc}
                            </label>
                          </div>
                        ))}
                    </div>
                  </>
                )}
                {jsondata?.qualificationList?.some(
                  (quals: any) => quals?.qualSection === "Research",
                ) && (
                  <>
                    <div className="x-small font-semibold text-black">
                      Research:
                    </div>
                    <div className="flex flex-wrap gap-[8px]">
                      {jsondata?.qualificationList
                        ?.filter(
                          (qualitem: any) =>
                            qualitem?.qualSection === "Research",
                        )
                        ?.map((qualChild: any, index: number) => (
                          <div className="form-black flex relative" key={index}>
                            {slug?.split("/")[1] !==
                              `${qualChild?.qualTextKey}-courses` && (
                              <Link
                                className="hidden"
                                id={
                                  keyName?.studyLevel + qualChild?.qualTextKey
                                }
                                href={{
                                  pathname: "/pgs/search",
                                  query: formUrl(
                                    keyName?.studyLevel,
                                    qualChild?.qualTextKey,
                                    false,
                                    qualChild?.subjectTextKey?.replaceAll(
                                      ",",
                                      "+",
                                    ),
                                  ),
                                }}
                              >
                                {qualChild?.qualDisplayDesc}
                              </Link>
                            )}
                            <input
                              checked={
                                filterState?.filterOrder?.qualification ==
                                  qualChild?.qualTextKey ||
                                prepopulateFilter?.studyLevel ===
                                  `${qualChild?.qualTextKey}-courses`
                              }
                              type="radio"
                              name="studylevel"
                              id={qualChild?.qualDisplayDesc}
                              value={qualChild?.qualDisplayDesc}
                              onChange={() => {
                                appendSearchParams(
                                  keyName?.studyLevel,
                                  qualChild?.qualTextKey,
                                  false,
                                  true,
                                  qualChild?.subjectTextKey?.replaceAll(
                                    ",",
                                    "+",
                                  ),
                                );
                              }}
                              className="rounded-[4px] outline-none absolute opacity-0"
                            />
                            <label
                              htmlFor={qualChild?.qualDisplayDesc}
                              className="btn btn-black-outline"
                            >
                              {qualChild?.qualDisplayDesc}
                            </label>
                          </div>
                        ))}
                    </div>
                  </>
                )}
              </>
            )}
            {process.env.PROJECT === "Whatuni" && (
              <div className="flex flex-wrap gap-[8px]">
                {jsondata?.qualificationList?.map(
                  (qualChild: any, index: number) => (
                    <div className="form-black flex relative" key={index}>
                      {slug?.split("/")[1] !==
                        `${qualChild?.qualTextKey}-courses` && (
                        <Link
                          className="hidden"
                          id={keyName?.studyLevel + qualChild?.qualTextKey}
                          href={{
                            pathname: `/${qualChild?.qualTextKey}-courses/${slug?.split("/")[2]}`,
                            query: formUrl(
                              keyName?.studyLevel,
                              qualChild?.qualTextKey,
                              false,
                              qualChild?.subjectTextKey?.replaceAll(",", "+"),
                            ),
                          }}
                        >
                          {qualChild?.qualDisplayDesc}
                        </Link>
                      )}
                      <input
                        checked={
                          prepopulateFilter?.studyLevel ==
                          `${qualChild?.qualTextKey}-courses`
                        }
                        type="radio"
                        name="studylevel"
                        id={qualChild?.qualDisplayDesc}
                        value={qualChild?.qualDisplayDesc}
                        onChange={() => {
                          // setPrepopulateFilter?.((prev: any) => ({
                          //   ...prev,
                          //   studyLevel: `${qualChild?.qualTextKey}-courses`,
                          // }));
                          appendSearchParams(
                            keyName?.studyLevel,
                            qualChild?.qualTextKey,
                            false,
                            true,
                            qualChild?.subjectTextKey?.replaceAll(",", "+"),
                          );
                        }}
                        className="rounded-[4px] outline-none absolute opacity-0"
                      />
                      <label
                        htmlFor={qualChild?.qualDisplayDesc}
                        className="btn btn-black-outline"
                      >
                        {qualChild?.qualDisplayDesc}
                      </label>
                    </div>
                  ),
                )}
              </div>
            )}
          </div>
        )}

        {jsondata?.subjectFilterList?.length > 0 && (
          <div className="flex flex-col gap-[16px]">
            <div className="flex flex-col gap-[4px]">
              <div className="text-para-lg font-semibold">Subject area</div>
              <div className="x-small font-semibold text-black uppercase">
                choose one subject area
              </div>
            </div>
            <div className="bg-white rounded-[22px] p-[11px_12px] border border-grey-300 hover:border-primary-500 md:p-[9px_12px]">
              <div className="flex item-center gap-[12px] relative">
                <Image
                  src="/static/assets/icons/search-result/search-black.svg"
                  width="20"
                  height="20"
                  alt="Search icon"
                />
                <input
                  type="text"
                  className="w-full focus:outline-none small text-black placeholder:text-gray-500"
                  aria-label="enter keyword"
                  placeholder="Search subjects"
                  value={subjectState?.subjectkeyword || ""}
                  onChange={(event) => {
                    subjectKeyWordSearch(event?.target?.value);
                  }}
                />
                {subjectState?.isSujectDropdownOpen && (
                  <div className="flex flex-col w-[calc(100%_+_28px)] absolute z-[1] bg-white shadow-custom-3 rounded-[8px] left-[-15px] top-[33px] custom-scrollbar-2 max-h-[367px] overflow-y-auto">
                    <div className="px-[16px] py-[12px] cursor-pointer">
                      <p className="x-small font-semibold text-black tracking-[1px] leading-[18px] uppercase">
                        Keyword search for
                      </p>
                      <p
                        className="small text-primary-400"
                        onClick={() => {
                          appendSearchParams(
                            keyName?.keyword,
                            subjectState?.subjectkeyword,
                          );
                          setSubjectState((prev: any) => ({
                            ...prev,
                            isSujectDropdownOpen: false,
                          }));
                        }}
                      >
                        '{subjectState?.subjectkeyword}'
                      </p>
                    </div>
                    {subjectState?.sortedSubjects?.length > 0 ? (
                      <ul>
                        {subjectState?.sortedSubjects?.map(
                          (subjects: any, index: number) => (
                            <li
                              key={index + 1}
                              className="px-[16px] py-[10px] block small hover:bg-blue-50 hover:underline cursor-pointer"
                              onClick={() => {
                                appendSearchParams(
                                  keyName?.subject,
                                  subjects?.subjectTextKey,
                                );
                              }}
                            >
                              {subjects?.categoryDesc}
                            </li>
                          ),
                        )}
                      </ul>
                    ) : (
                      <p>No match found</p>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className={`flex flex-col gap-[12px] transition-all duration-300 ease-in-out $
                      ${subjectState?.isSubjectOpen ? "-translate-x-full h-0 hidden" : "translate-x-0 h-auto"}
                      `}
            >
              <div className="flex flex-col gap-[12px] max-h-[355px] overflow-y-auto custom-scrollbar-2">
                {parentSubjectList?.map((l1Subjects: any, index: any) => (
                  <div
                    key={index}
                    onClick={() => {
                      subjectClicked(l1Subjects?.categoryDesc, true);
                    }}
                    className="flex items-center gap-[4px] text-blue-400 small font-semibold cursor-pointer hover:underline"
                  >
                    {l1Subjects?.categoryDesc}

                    <RightArrowSvg />
                  </div>
                ))}
              </div>
            </div>
            <div
              className={`
                        bg-white transition-all duration-300 ease-in-out
                        ${subjectState?.isSubjectOpen ? "translate-x-0 block" : "hidden -translate-x-full"}
                      `}
            >
              {L2subjects?.map((subjects: any, index: number) => (
                <L2subjectList
                  key={index}
                  subjectsArray={subjects}
                  selectedSubject={subjectState?.selectedSubject}
                  isSubjectOpen={subjectState?.isSubjectOpen}
                  subjectClicked={subjectClicked}
                  formUrl={formUrl}
                  slug={slug}
                  appendSearchParams={appendSearchParams}
                  prepopulateFilter={prepopulateFilter}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </Accordion>
  );
};

export default SubjectAccordianFilter;
